export default import.meta.ROLLDOWN_FILE_URL_O0V5WS5$4bim9OQ6gLASIg